module.exports = __webpack_public_path__ + "static/media/bei1.99fef748.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bei1.png
// module id = 428
// module chunks = 0